import type { CSSProperties } from 'react';

export const GRAPH_IDENTITY_COLORS = ['#ff3b30', '#3b82f6', '#a855f7', '#14b8a6'] as const;

type GraphIdentityBadgeProps = {
  order: number;
  variant?: 'panel' | 'usage';
  ariaLabel?: string;
};

export function graphIdentity(order: number) {
  return {
    label: `G${order + 1}`,
    color: GRAPH_IDENTITY_COLORS[order % GRAPH_IDENTITY_COLORS.length],
  };
}

export function GraphIdentityBadge({
  order,
  variant = 'usage',
  ariaLabel = `Graph ${order + 1}`,
}: GraphIdentityBadgeProps) {
  const identity = graphIdentity(order);

  return (
    <span
      className={`graph-identity-badge graph-identity-badge--${variant}`}
      style={{ '--graph-identity-color': identity.color } as CSSProperties}
      aria-label={ariaLabel}
    >
      {identity.label}
    </span>
  );
}
